module.exports = __webpack_public_path__ + "img/abanca.1a203997.svg";